import { useNavigate, useSearchParams } from 'react-router-dom';

const difficulties = [
  { id: 'easy', name: 'Easy', icon: '🌱', description: 'Basic facts & dates', color: 'green' },
  { id: 'medium', name: 'Medium', icon: '🌿', description: 'Detailed knowledge', color: 'yellow' },
  { id: 'hard', name: 'Hard', icon: '🌳', description: 'Expert level', color: 'red' }
];

export default function DifficultySelection() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category');
  const mode = searchParams.get('mode') || 'practice';

  const handleDifficultySelect = (difficulty) => {
    // Navigate to quiz with category, difficulty, and mode
    navigate(`/quiz?category=${category}&difficulty=${difficulty}&mode=${mode}`);
  };

  const getColorClasses = (color) => {
    const colors = {
      green: 'from-green-500 to-green-700 hover:from-green-600 hover:to-green-800',
      yellow: 'from-yellow-500 to-yellow-700 hover:from-yellow-600 hover:to-yellow-800',
      red: 'from-red-500 to-red-700 hover:from-red-600 hover:to-red-800'
    };
    return colors[color];
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-600 to-purple-800 p-6">
      <div className="max-w-4xl mx-auto">
        <div className="bg-white rounded-lg shadow-xl p-8">
          <div className="flex items-center justify-between mb-8">
            <h1 className="text-3xl font-bold text-gray-800">Select Difficulty</h1>
            <button
              onClick={() => navigate('/categories')}
              className="btn btn-secondary"
            >
              ← Back
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {difficulties.map((diff) => (
              <div
                key={diff.id}
                onClick={() => handleDifficultySelect(diff.id)}
                className={`bg-gradient-to-br ${getColorClasses(diff.color)} rounded-lg p-8 cursor-pointer transition-all transform hover:scale-105 shadow-lg text-white`}
              >
                <div className="text-6xl mb-4 text-center">{diff.icon}</div>
                <h3 className="text-2xl font-bold mb-3 text-center">{diff.name}</h3>
                <p className="text-center text-white/90">{diff.description}</p>
              </div>
            ))}
          </div>

          <div className="mt-8 text-center">
            <button
              onClick={() => handleDifficultySelect('all')}
              className="btn btn-primary"
            >
              Mix All Difficulties
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
